//export const TERRAIN_COLOR_PLAIN = '#88aa00';
export const TERRAIN_COLOR_PLAIN = '#88aa55';
